function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MagicFetch = /*#__PURE__*/function () {
  function MagicFetch() {//		this.api = api;
    //		this.query = query === null ? '' : '?' + query;

    _classCallCheck(this, MagicFetch);
  }

  _createClass(MagicFetch, [{
    key: "api",
    get: function get() {
      return '';
    }
  }, {
    key: "query",
    get: function get() {
      return '';
    }
  }, {
    key: "list",
    value: function list(page, sort, quickSearch, search, limit) {
      return fetch(this.api + '/list/' + page + this.query, {
        method: 'POST',
        body: JSON.stringify({
          sort: sort,
          quickSearch: quickSearch,
          search: search,
          limit: limit
        })
      });
    }
  }, {
    key: "get",
    value: function get(id) {
      return fetch(this.api + '/get/' + id + this.query);
    }
  }, {
    key: "blank",
    value: function blank() {
      return fetch(this.api + '/get' + this.query);
    }
  }, {
    key: "create",
    value: function create(data) {
      return fetch(this.api + '/save' + this.query, {
        method: 'POST',
        body: JSON.stringify(data)
      });
    }
  }, {
    key: "save",
    value: function save(id, data) {
      return fetch(this.api + '/save/' + id + this.query, {
        method: 'POST',
        body: JSON.stringify(data)
      });
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return fetch(this.api + '/delete/' + id + this.query, {
        method: "DELETE"
      });
    }
  }, {
    key: "attachment",
    value: function attachment(action, data) {
      return fetch(this.api + '/attachment/' + action, {
        method: 'POST',
        body: data
      });
    }
  }]);

  return MagicFetch;
}();

export { MagicFetch as default };